import { create } from 'zustand';
import axios from 'axios';

const api = axios.create({
  baseURL: 'https://api.masark.co/',
  withCredentials: true,
});

const useDataStore = create((set) => ({
  courses: [],
  allTrainers: [],
  allUsers: [],
  moodleCourses: [],
  courseContent: null,
  selectedCourse: "",
  selectedTrainer: null,
  loading: false,
  error: null,

  // --- Courses ---
  getAllCourses: async () => {
    set({ loading: true, error: null });
    try {
      const res = await api.get('/Courses');
      set({ courses: res.data || [], loading: false });
    } catch (err) {
      set({
        error: err.response?.data?.message || 'Failed to fetch courses',
        loading: false,
      });
    }
  },

  createCourse: async (newCourseData) => {
    set({ loading: true, error: null });
    try {
      const token = localStorage.getItem('accessToken');
      const res = await api.post('/Courses', newCourseData, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      set((state) => ({
        loading: false,
        courses: [...state.courses, res.data],
      }));
      return res.data;
    } catch (err) {
      set({
        error: err.response?.data?.message || 'Failed to create course',
        loading: false,
      });
      return null;
    }
  },

  updateCourse: async (courseId, updatedData) => {
    set({ loading: true, error: null });
    try {
      const token = localStorage.getItem('accessToken');
      const res = await api.patch(`/courses/${courseId}`, updatedData, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      set((state) => ({
        loading: false,
        courses: state.courses.map((course) =>
          course._id === courseId ? res.data : course
        ),
      }));
      return res.data;
    } catch (err) {
      set({
        error: err.response?.data?.message || 'Failed to update course',
        loading: false,
      });
      return null;
    }
  },

  deleteCourse: async (courseId) => {
    try {
      const token = localStorage.getItem('accessToken');
      await api.delete(`/courses/${courseId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      set((state) => ({
        courses: state.courses.filter((course) => course._id !== courseId),
      }));
      return true;
    } catch (err) {
      set({
        error: err.response?.data?.message || 'Failed to delete course',
      });
      return false;
    }
  },

  // --- Trainers ---
  getAllTrainers: async () => {
    set({ loading: true, error: null });
    try {
      const token = localStorage.getItem('accessToken');
      const res = await api.get('/trainers', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      set({ allTrainers: res.data || [], loading: false });
    } catch (err) {
      set({
        error: err.response?.data?.message || 'Failed to fetch trainers',
        loading: false,
      });
    }
  },


  createTrainer: async (trainerData) => {
    set({ loading: true, error: null });
    try {
      const token = localStorage.getItem('accessToken');
      const res = await api.post('/trainers', trainerData, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      set((state) => ({
        loading: false,
        allTrainers: [...state.allTrainers, res.data],
      }));
      return res.data;
    } catch (err) {
      set({
        error: err.response?.data?.message || 'Failed to add trainer',
        loading: false,
      });
      return null;
    }
  },


  updateTrainer: async (trainerId, updatedData) => {
    set({ loading: true, error: null });
    try {
      const token = localStorage.getItem('accessToken');
      const res = await api.patch(`/trainers/${trainerId}`, updatedData, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      set((state) => ({
        loading: false,
        allTrainers: state.allTrainers.map((trainer) =>
          trainer._id === trainerId ? res.data : trainer
        ),
      }));
      return res.data;
    } catch (err) {
      set({
        error: err.response?.data?.message || 'Failed to update trainer',
        loading: false,
      });
      return null;
    }
  },

  deleteTrainer: async (trainerId) => {
    try {
      const token = localStorage.getItem('accessToken');
      await api.delete(`/trainers/${trainerId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      set((state) => ({
        allTrainers: state.allTrainers.filter((trainer) => trainer._id !== trainerId),
      }));
      return true;
    } catch (err) {
      console.error('Error deleting trainer:', err);
      set({
        error: err.response?.data?.message || 'Failed to delete trainer',
      });
      return false;
    }
  },



  getAllUsers: async () => {
    set({ loading: true, error: null });
    try {
      const token = localStorage.getItem('accessToken');
      const res = await api.get('/users', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      set({ allUsers: res.data || [], loading: false });
    } catch (err) {
      set({
        error: err.response?.data?.message || 'Failed to fetch users',
        loading: false,
      });
    }
  },

  getCourseDetails: async (courseId) => {
    set({ loading: true, error: null });
    try {
      const token = localStorage.getItem('accessToken');
      const res = await api.get(`/Courses/${courseId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      set({ selectedCourse: res.data, loading: false });
    } catch (err) {
      set({
        error: err.response?.data?.message || 'Failed to fetch course details',
        loading: false,
      });
    }
  },


  getTrainerDetails: async (trainerId) => {
    set({ loading: true, error: null });
    try {
      const token = localStorage.getItem('accessToken');
      const res = await api.get(`/trainers/${trainerId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      set({ selectedTrainer: res.data, loading: false });

    } catch (err) {
      set({
        error: err.response?.data?.message || 'Failed to fetch  Trainer details',
        loading: false,
      });
    }
  },

  // getCourseContent: async () => {
  //   set({ loading: true, error: null });
  //   try {
  //     const token = localStorage.getItem('accessToken');
  //     const res = await api.get('https://api.masark.co/Courses/content', {
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //       },
  //     });
  //     set({ courseContent: res, loading: false });
  //   } catch (err) {
  //     set({
  //       error: err.response?.message || 'Failed to fetch course content',
  //       loading: false,
  //     });
  //   }
  // },

  getMoodleCourses: async () => {
    set({ loading: true, error: null });
    try {
      const res = await api.get('/moodle-courses');

      set({ moodleCourses: res.data?.data?.courses || [], loading: false });
    } catch (err) {
      set({
        error: err.response?.data?.message || 'Failed to fetch moodle courses',
        loading: false,
      });
    }
  },



  // user courses


getMyCourses: async () => {
  const token = localStorage.getItem('accessToken');
  const res = await api.get("/Courses/mine", {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  set({ courses: res.data });
},

getCourseContent: async () => {
  const token = localStorage.getItem('accessToken');
  const res = await api.get("/Courses/content", {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  set({ courseContent: res.data });
},



}));

export default useDataStore;


